import React from 'react';

interface SessionContextType {
    sessionName?: string;
    setSessionName: (template: string) => void;
    sessionPassword?: string;
    setSessionPassword: (template: string) => void;
}

export default React.createContext<SessionContextType>({} as any);